'use strict';

var Social = require('./lib/social');
var Nav = require('./lib/nav');
var Utils = require('../utils/utils');

// Constructor
var MainFooter = function() {
  var self = this;

  self.config = {
    socialEl: '.main-footer__social',
    socialIconTemplate: function(name) {
      var template = '<span class="icon icon--' + name + '-white"></span>'
      return template
    },
    navEl: '.main-footer__nav',
    navContainer: '<div class="main-footer__nav-container"></div>',
    navContainerEl: '.main-footer__nav-container',
    navButton: '<button type="button" class="main-footer__nav-toggle">Legal<span class="icon icon--caret-white"></span></button>'
  }

  self.init = function() {
    var navConfig = {
      el: self.config.navEl,
      container: self.config.navContainer,
      containerEl: self.config.navContainerEl,
      button: self.config.navButton
    };
    var mdMatch = function() {
      new Nav(navConfig).destroy();
    };
    new Social({
      el: self.config.socialEl,
      template: self.config.socialIconTemplate
    }).init();
    new Nav(navConfig).init();
    new Utils().matchmediaHandler('MEDIUM', mdMatch, null);
  }
};

module.exports = MainFooter;
